// generated by genversion
const version = '6.14.4';

export { version };
//# sourceMappingURL=version.mjs.map
